import type { IconProps } from './../../models/icon';

export function GiftGivingIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M5.04619 22.3481L0.856934 18.8571V12.8571H5.43677C6.34609 12.8571 7.21815 13.2183 7.86115 13.8613L9.85693 15.8571C10.567 16.5672 10.567 17.7185 9.85693 18.4285C9.65862 18.6269 9.42581 18.7695 9.17789 18.8571H16.8569C18.4349 18.8571 19.7141 20.1363 19.7141 21.7143C19.7141 22.5032 19.0745 23.1428 18.2856 23.1428H7.24111C6.43904 23.1428 5.66235 22.8617 5.04619 22.3481Z"
        />
        <path
          fill={secondaryColor}
          d="M23.1431 4.28571H11.1431V12.8571H23.1431V4.28571Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1431 4.28571H11.1431V12.8571H23.1431V4.28571Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M17.1431 4.28571V12.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.5713 0.857117L17.1427 4.28569L19.7141 0.857117"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 18.8563L5.04619 22.3475C5.66235 22.8609 6.43903 23.142 7.24111 23.142H18.2854C19.0745 23.142 19.7141 22.5024 19.7141 21.7135C19.7141 20.1355 18.4349 18.8563 16.8569 18.8563H9.17858"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.99979 17.142L7.28551 18.4277C7.99558 19.1378 9.14685 19.1378 9.85694 18.4277C10.567 17.7177 10.567 16.5664 9.85694 15.8563L7.86113 13.8605C7.21815 13.2175 6.34608 12.8563 5.43677 12.8563H0.856934"
        />
      </g>
    </svg>
  );
}
